import { defineStyleConfig } from "@chakra-ui/react";

export default defineStyleConfig({});
